import { useState } from 'react';

import { dateTime } from '@/_shared';

import { now, yesterday } from './constants';

export function useCustomDateRange() {
  return useState({
    from: dateTime.format(yesterday, 'YYYY-MM-DD'),
    to: dateTime.format(now, 'YYYY-MM-DD'),
  });
}

export type UseCustomDateRange = ReturnType<typeof useCustomDateRange>;
